(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initProductListTabs(root = document) {
      const wrappers = root.querySelectorAll('.product-list-tabs--multiple');

      wrappers.forEach((wrapper) => {
        const tabNav = wrapper.querySelector('.tab-nav');
        const tabs = Array.from(wrapper.querySelectorAll('.collection-tab'));

        if (!tabNav || !tabs.length) return;

        if (wrapper.dataset.tabsInitialized === 'true') return;
        wrapper.dataset.tabsInitialized = 'true';

        tabNav.innerHTML = '';
        tabNav.setAttribute('role', 'tablist');

        const fragment = document.createDocumentFragment();

        tabs.forEach((tab, index) => {
          const titleEl = tab.querySelector('.collection-tab-title');
          if (!titleEl) return;

          const titleText = titleEl.dataset.title || titleEl.querySelector('h2')?.textContent.trim();

          const tabId = tab.dataset.tabId;
          if (!tabId) return;

          const isActive = index === 0;

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.id = `tab-${tabId}`;
          btn.className = 'tab-nav__button';
          btn.dataset.tabTarget = tabId;

          // Label span
          const label = document.createElement('span');
          label.className = 'tab-nav__label';
          label.textContent = titleText;

          btn.appendChild(label);

          // ARIA
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-selected', isActive);
          btn.setAttribute('aria-controls', `panel-${tabId}`);
          btn.tabIndex = isActive ? 0 : -1;

          tab.classList.toggle('is-active', isActive);
          tab.toggleAttribute('hidden', !isActive);

          fragment.appendChild(btn);
        });

        tabNav.appendChild(fragment);

        const buttons = Array.from(tabNav.querySelectorAll('[role="tab"]'));

        function setActiveTab(tabId, focus = true) {
          buttons.forEach((btn) => {
            const isActive = btn.dataset.tabTarget === tabId;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-selected', isActive);
            btn.tabIndex = isActive ? 0 : -1;
            if (isActive && focus) btn.focus();
          });

          tabs.forEach((tab) => {
            const isActive = tab.dataset.tabId === tabId;
            tab.classList.toggle('is-active', isActive);
            tab.toggleAttribute('hidden', !isActive);
          });
        }

        // Mouse interaction
        tabNav.addEventListener('click', (e) => {
          const btn = e.target.closest('[role="tab"]');
          if (!btn) return;
          setActiveTab(btn.dataset.tabTarget);
        });

        // Keyboard interaction
        tabNav.addEventListener('keydown', (e) => {
          const currentIndex = buttons.indexOf(document.activeElement);
          if (currentIndex === -1) return;

          let nextIndex = null;

          switch (e.key) {
            case 'ArrowRight':
              nextIndex = (currentIndex + 1) % buttons.length;
              break;
            case 'ArrowLeft':
              nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
              break;
            case 'Home':
              nextIndex = 0;
              break;
            case 'End':
              nextIndex = buttons.length - 1;
              break;
            case 'Enter':
            case ' ':
              e.preventDefault();
              setActiveTab(buttons[currentIndex].dataset.tabTarget);
              return;
            default:
              return;
          }

          e.preventDefault();
          buttons[nextIndex].focus();
        });
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      initProductListTabs();
    });

    document.addEventListener('shopify:section:load', (e) => {
      initProductListTabs(e.target);
    });

    document.addEventListener('shopify:block:select', (e) => {
      const section = e.target.closest('section');
      if (!section) return;

      section.querySelectorAll('.product-list-tabs--multiple').forEach((w) => delete w.dataset.tabsInitialized);

      initProductListTabs(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
